import { Container } from "../../../theme/styles";
import styled from "styled-components";

interface paramsProps {
  body: string
}

function Markdown(props: { block: paramsProps }) { 
  

  const input = props.block.body;


  
  return (
    <>
      <Content>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img src={input} width="100%" />
      </Content>
    </>
  );
}

export default Markdown;


const Content = styled(Container)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  font-size: 20px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-align: justify;
  text-justify: inter-word;
  
  * {
    text-indent: inherit !important;
    font-family: inherit !important;
    font-style: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    text-align: inherit !important;
    text-justify: inherit !important;
    font-size: inherit !important;
  }
  
  p {
    padding: 0 0 40px;
  }
  strong {
    font-weight: bold;
  }
  b {
    font-weight: bold;
  }
  i {
    font-style: italic;
  }
  ul {
    padding: 0 0 0 0;
    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      padding: 0 0 0 0;  
    }
  }
  li {
    text-indent: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
    padding: 0 26px;
    // text-align: center;
    margin: auto;
    font-weight: 400;

  }
`;
